export default __webpack_public_path__ + "static/media/test-1.2b2de8f8.svg";